import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { style, iconStack, materialIcons, columnStyle } from './style';
import $ from 'jquery';

export default class TableHandler extends Component {

  processBindRules(item, rules) {
    if (item && rules) {
      let check = true;
      if (rules.show && Object.keys(rules.show).length > 0) {
        for (let key in item) {
          for (let ruleField in rules.show) {
            if (key == ruleField && item[key] != rules.show[ruleField]) {
              check = false;
            }
          }
        }
      }
      return check;
    }
  }

  addPopover(container) {
    container.popover({
      placement: "bottom",
      trigger: "hover",
    });
  }

  deletePopover(container) {
    container.popover('dispose');
  }

  componentWillUnmount() {
    this.deletePopover($('.button-has-popover'));
  }

  componentDidMount() {
    const menuOption = $('.button-has-popover');
    this.deletePopover(menuOption);
    this.addPopover(menuOption);
  }

  componentDidUpdate() {
    const menuOption = $('.button-has-popover');
    this.deletePopover(menuOption);
    this.addPopover(menuOption);
  }

  render() {
    const check = this.processBindRules(this.props.item, this.props.bind);

    if (check === false) {
      return null;
    }

    this.props.context.itemId = this.props.id;
    this.props.handler.bind(this.props.context);

    let container = null;
    if(this.props.hasWrapper) {
      let id = null;

      if (this.props.itemId) {
        id = this.props.item[this.props.itemId];
      } else {
        id = this.props.id;
      }
      container = (
        <span style={style.iconStack} onClick={() => { this.props.handler(id); }}>
            <i style={ iconStack.iconStack3x } className={this.props.icon[0]}></i>
            <i style={ iconStack.iconStack1x } className={this.props.icon[1]}></i>
        </span>
      )
    } else {
      container = (
        <span style={style.default} onClick={() => { this.props.handler(this.props.id); }}>
          <i style={ materialIcons.materialIcon } className={this.props.icon}>{this.props.iconClass}</i>
        </span>
      )
    }

    return (
      <div className="col-3 button-has-popover" data-content={this.props.title} style={style.columnStyle}>{container}</div>
    )
  }
}

TableHandler.propTypes = {
  icon: PropTypes.any,
  iconClass: PropTypes.string,
  handler: PropTypes.func,
  id: PropTypes.any,
  hasWrapper: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/сomponents/TableHandler/index.js